import { render, staticRenderFns } from "./DisableAsset.vue?vue&type=template&id=04863c89"
import script from "./DisableAsset.vue?vue&type=script&lang=js"
export * from "./DisableAsset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports